module.exports = __webpack_public_path__ + "pc/img/dimensionalcode.e657ae72.png";